import { useEffect, useRef } from 'react';

import Video from '../Components/VideoWrapped25.js'

import './pages.css';
import './mshops.css';
import './wrapped25.css';

function TiendaNube() {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const sections = container.querySelectorAll('section');

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                    } else {
                        entry.target.classList.remove('is-visible');
                    }
                });
            },
            {
                root: container,
                threshold: 0.3,
            }
        );

        sections.forEach((sec) => observer.observe(sec));

        const handleScroll = () => {
            const parallaxSections = container.querySelectorAll('.parallax-center');
            const vh = window.innerHeight;

            parallaxSections.forEach((sec) => {
                const rect = sec.getBoundingClientRect();
                let progress = 1 - rect.top / vh;
                progress = Math.max(0, Math.min(progress, 1)); // clamp 0–1

                sec.style.setProperty('--progress', progress.toString());
            });
        };

        container.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            observer.disconnect();
            container.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className='wrapped25' ref={containerRef}>
                

              
                <Video/>



                
            </div>
        </>
    );
}

export default TiendaNube;